
export const indexedActionTypes = {
    ADD_STATE           : '[indexed_main] Add state',
    REMOVE_STATE        : '[indexed_main] Remove state',
    FIND_STATE          : '[indexed_main] Find state',
    userIsAdmin         : '[indexed_main] Identify if user is admin ',
    app                 : '[indexed_main] Selected Menu App',
    module              : '[indexed_main] Selected Module',
    udn                 : '[indexed_main] Selected UDN',
    menu                : '[indexed_main] Selected menu',
    category            : '[indexed_main] Control category',
    view                : '[indexed_main] Set view mode',
    mapConfig           : '[indexed_main] Configuration for map ',
    clearState          : '[indexed_main] Clear state',
    loading             : '[indexed_main] Change loading state',
    parent              : '[indexed_main] Parent model of the selected object ',
    domainObject        : '[indexed_main] Selected object/item',
    formData            : '[indexed_main] Set the form behavior',
    tableParams         : '[indexed_list_props] Reset dropdown boxes',
    listDomainObjects   : '[indexed_list_props] List of object/items',
    filter              : '[indexed_list_props] Search filter params',
    addItem             : '[indexed_list_props] Add item to list',
    addAllItems         : '[indexed_list_props] Add all items to list',
    removeItem          : '[indexed_list_props] Remove item from list',
    changeItem          : '[indexed_list_props] Change list item if edited',
    changeAllItems      : '[indexed_list_props] Change all list items if edited',
}

const initialState = {
    userIsAdmin: false,
    loading: false,
    viewMode : 'LIST',
    app : {},
    udn : {},
    category : null,
    domainObject    : null,
    listDomainObjects   : [],
    pageSize            : 10,
    pageIndex           : 0,
    totalSize           : 0,
    currentPage         : 1,
    filter              : null,
    editMode        : false,
    disableInputs   : false,
    saveSuccess     : false,
    resetCombos     : false,
}

const indexedReducer = (state = [], action) => {
    switch (action.type) {
        // ...existing cases...
        case indexedActionTypes.ADD_STATE:
            // Check if state with the same path already exists
            if (state?.some(s => s.path === action.payload.path)) {
                return state;
            }
            // Add new state to the array
            return [...state, { path: action.payload.path, data: initialState }];
        case indexedActionTypes.REMOVE_STATE:
            // Remove state with the specified path from the array
            return state?.filter(s => s.path !== action.payload);

        // MAIN PROPS
        case indexedActionTypes.clearState:
            return state?.map(s => s.path === action.path ? { ...s, data: initialState } : s)
        case indexedActionTypes.loading:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, loading: action.payload } } : s)
        case indexedActionTypes.view:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, viewMode: action.payload } } : s)
        case indexedActionTypes.menu:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, menu: action.payload } } : s)
        case indexedActionTypes.module:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, module: action.payload } } : s)
        case indexedActionTypes.app:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, app: action.payload } } : s)
        case indexedActionTypes.udn:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, udn: action.payload } } : s)
        case indexedActionTypes.parent:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, parent: action.payload } } : s)
        case indexedActionTypes.mapConfig:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, mapConfig: action.payload } } : s)
        case indexedActionTypes.category:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, category: action.payload } } : s)
        case indexedActionTypes.userIsAdmin:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, userIsAdmin: action.payload } } : s)
        case indexedActionTypes.domainObject:
            return state?.map(s => s.path === action.path
                ? {
                    ...s,
                    data: {
                        ...s.data,
                        domainObject: action.payload
                    } }
                : s
            )
        case indexedActionTypes.formData:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, editMode: action.payload.editMode, disableInputs: action.payload.disableInputs, saveSuccess: action.payload.saveSuccess } } : s)

        // LIST PROPS
        case indexedActionTypes.tableParams:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, pageSize: action.payload.pageSize, pageIndex: action.payload.pageIndex, totalSize: action.payload.totalSize, currentPage: action.payload.currentPage } } : s)
        case indexedActionTypes.listDomainObjects:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, listDomainObjects: action.payload } } : s)
        case indexedActionTypes.filter:
            return state?.map(s => s.path === action.path ? { ...s, data: { ...s.data, filter: action.payload } } : s)
        case indexedActionTypes.addItem: {
            return state?.map(s => {
                if (s.path === action.path) {
                    const resultList = s.data.listDomainObjects.slice();
                    resultList.unshift(action.payload);
                    return { ...s, data: { ...s.data, listDomainObjects: resultList } };
                }
                return s;
            });
        }
        case indexedActionTypes.addAllItems: {
            return state?.map(s => {
                if (s.path !== action.path)
                    return s

                const copyList = s.data.listDomainObjects.slice();
                const resultList = [...copyList, ...action.payload];

                return { ...s, data: { ...s.data, listDomainObjects: resultList } };

            });
        }
        case indexedActionTypes.changeItem:{
            return state?.map(s => {
                if (s.path === action.path) {
                    const resultList = s.data.listDomainObjects.slice();
                    const index = resultList.findIndex(i => i.id === action.payload.id);

                    if(index === -1) return s;

                    resultList[index] = action.payload;
                    return { ...s, data: { ...s.data, listDomainObjects: resultList } };
                }
                return s;
            });
        }
        case indexedActionTypes.changeAllItems:{
            return state?.map(s => {
                if (s.path !== action.path)
                    return s

                const resultList = s.data.listDomainObjects.slice();

                action.payload.forEach(item => {
                    const index = resultList.findIndex(i => i.id === item.id);
                    resultList[index] = item;
                })

                return { ...s, data: { ...s.data, listDomainObjects: resultList } };
            });
        }
        case indexedActionTypes.removeItem: {
            return state?.map(s => {
                if (s.path === action.path) {
                    const resultList = s.data.listDomainObjects.filter(item => item.id !== action.payload);
                    return { ...s, data: { ...s.data, listDomainObjects: resultList } };
                }
                return s;
            });
        }
        default:
            return state
    }
}

export default indexedReducer